import type { FaireProductEntity } from "../../entity_types/product";

export const p_t6w6yvxnyf: FaireProductEntity = {
  token: "p_t6w6yvxnyf",
  type: "product",
  name: "FOOTBALL themed baseball cap, adjustable - Blank",
  brandToken: "b_48we1z8tb5",
  brandName: "Olive & Pique",
  imageUrl:
    "https://cdn.faire.com/fastly/5c64c91dbf57c7e98a3ffdd639d63fd99fd49a1f517c041fb24ede0915500d8c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/eacc33d6e4a1430e7dc58fe286081428c9f586c50c494062157b883e38605510.jpeg",
  ],
  priceDollars: 10.39,
  description:
    "FOOTBALL themed baseball cap with white laced stitch detail. Get gameday ready! Great for custom embroidery, out on the field, even for our little league moms!",
  tags: [],
  msrpDollars: 41.57,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:55:09.818Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
